type ImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type NotificationType = 'error' | 'success' | 'warning';

interface HapticFeedbackApi {
  impactOccurred: (style: ImpactStyle) => void;
  selectionChanged: () => void;
  notificationOccurred: (type: NotificationType) => void;
}

function getHapticApi(): HapticFeedbackApi | undefined {
  const webApp = window.Telegram?.WebApp;
  return webApp?.isVersionAtLeast?.('6.1') ? webApp.HapticFeedback : undefined;
}

export function hapticImpact(style: ImpactStyle = 'light'): void {
  try {
    getHapticApi()?.impactOccurred(style);
  } catch {
    // Graceful fallback — visual feedback handled by UI
  }
}

export function hapticSelection(): void {
  try {
    getHapticApi()?.selectionChanged();
  } catch {
    // noop
  }
}

export function hapticSuccess(): void {
  try {
    getHapticApi()?.notificationOccurred('success');
  } catch {
    // noop
  }
}

export function hapticWarning(): void {
  try {
    getHapticApi()?.notificationOccurred('warning');
  } catch {
    // noop
  }
}

export function hapticError(): void {
  try {
    getHapticApi()?.notificationOccurred('error');
  } catch {
    // noop
  }
}
